exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-788a6796] {\n  margin-left: 24px;\n  margin-right: 24px;\n}\n.content[data-v-788a6796] {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n.seeker-list[data-v-788a6796] {\n  padding-left: 16px;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n.footer-box[data-v-788a6796] {\n  width: 100%;\n  height: 64px;\n  border-top: solid thin #ccc;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  overflow: auto;\n}\n.footer-box button[data-v-788a6796] {\n    width: 47%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-788a6796","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Manage/ModalChangeCustomColumn.vue
// module id = k/RF
// module chunks = 3